import { render, staticRenderFns } from "./DnSelect.vue?vue&type=template&id=087da535"
import script from "./DnSelect.ts?vue&type=script&lang=ts&external"
export * from "./DnSelect.ts?vue&type=script&lang=ts&external"
import style0 from "./DnSelect.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports